




import {
  SfModal,
  SfHeading,
  SfNotification
} from '@storefront-ui/vue';

import PasswordChangeForm from "@/components/MyAccount/PasswordChangeForm.vue";

export default {
  name: 'PasswordExpiredModal',
  components: {
    SfHeading,
    SfModal,
    SfNotification,
    PasswordChangeForm
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    isModalOpen(): boolean { return this.$store.getters.getProfile?.mustUpdatePassword }
  }
};
